/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{toPt as r}from"../../../core/screenUtils.js";function e(e){return r(e)}export{e as castSizeFromStringOrNumber};
